import React, { Component } from "react";

class Result extends Component {
  state = {
    shownTheory: {}
  };

  showTheory(i) {
    this.setState(prevState => {
      prevState.shownTheory[i] = true;
      return prevState;
    });
  }

  hideTheory(i) {
    this.setState(prevState => {
      prevState.shownTheory[i] = false;
      return prevState;
    });
  }
  render() {
    const { answers, QUIZ, redo } = this.props;

    let questions = QUIZ.length;
    let correctAnswers = answers.filter(a => a === true).length;
    let smiley;
    switch (true) {
      case correctAnswers === questions:
        smiley = "fa-grin-alt";
        break;
      case correctAnswers > questions / 2:
        smiley = "fa-meh";
        break;
      default:
        smiley = "fa-sad-cry";
        break;
    }

    return (
      <section className="section">
        <div className="container content">
          <div className="level level-item">
            <h1 style={{ paddingBottom: "0.5em" }}>
              Результат: {correctAnswers}/{questions}
            </h1>
          </div>
          <div className="level level-item">
            <span className="icon is-large" style={{ paddingBottom: "1.5em" }}>
              <i className={["far fa-5x", smiley].join(" ")} />
            </span>
          </div>
          {correctAnswers < questions
            ? [
                <div className="level level-item" key="mistakes">
                  <h2>Ошибки:</h2>
                </div>,
                answers.map((answer, i) => {
                  if (answer === false) {
                    return (
                      <div className="level level-item" key={i}>
                        <article className="message result mistake">
                          <div className="message-body">
                            <div className="is-size-6 columns is-mobile">
                              <div className="column is-10">
                                📖 {QUIZ[i].title}
                              </div>
                              <div className="column">
                                {!this.state.shownTheory[i] ? (
                                  <span
                                    onClick={() => this.showTheory(i)}
                                    style={{ cursor: "pointer" }}
                                  >
                                    ℹ️
                                  </span>
                                ) : null}
                              </div>
                            </div>
                            <div className="is-size-6">
                              ✅{" "}
                              {
                                QUIZ[i].variants.find(v => v.correct === true)
                                  .title
                              }
                            </div>
                            {this.state.shownTheory[i] ? (
                              <div className="is-size-6">
                                <div className="notification is-warning theory">
                                  <button
                                    className="delete"
                                    onClick={() => this.hideTheory(i)}
                                  />
                                  {QUIZ[i].theory
                                    .split("\n")
                                    .map((item, key) => {
                                      return <div key={key}>{item}</div>;
                                    })}
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </article>
                      </div>
                    );
                  }
                  return null;
                })
              ]
            : null}
        </div>
        <div className="level level-item">
          <a
            className="icon is-large is-size-5"
            onClick={redo}
            style={{ whiteSpace: "nowrap" }}
          >
            еще раз&nbsp;
            <i className={["fas fa-redo"].join(" ")} />
          </a>
        </div>
      </section>
    );
  }
}
export default Result;
